/*------------------------------------------------------------------
Import Requirements
------------------------------------------------------------------*/

import cssVars from 'css-vars-ponyfill';

/*------------------------------------------------------------------
CSS Variables
------------------------------------------------------------------*/

cssVars();